// Styles for DropDownComponent go here.
import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledDropDownComponent = styled.div`
  position: relative;

  .region-el {
    cursor: pointer;
  }

  .dropdown-container-div {
    position: absolute;
    z-index: 2;
    width: 100%;
  }
  .subtitle-text {
    margin-top: ${toRem(20)};
  }

  .luxury-dropdown-main {
    box-shadow: ${baseVariables.shadows.boxShadowPopover};
  }

  .active {
    background-color: ${baseVariables.color['neutral20']};
    border-radius: ${toRem(8)};
  }

  li {
    list-style: none;
  }

  .m-dropdown-container .m-dropdown-action-bar {
    background-color: unset !important;
  }

  @media only ${baseVariables.mediaQuery.lg} {
    border-radius: ${toRem(8)};
    .luxury-dropdown-main {
      border-radius: unset !important;
      box-shadow: unset !important;
    }

    .apply-button {
      display: none;
    }
  }

  .m-input-field {
    caret-color: ${baseVariables.color['base10']};
  }
`;
